/**
 * Constants for the routing.
 *
 * @summary constants for the routing.
 * @author Dominik Haas-Artho
 *
 * Created at     : 2019-10-23 16:34:23
 * Last modified  : 2021-07-29 09:16:23
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const LANDING_PATH = '/';
export const LANDING_PAGENAME = 'LandingPage';
export const BROWSE_PATH = '/browse';
export const BROWSE_PAGENAME = 'BrowsePage';
export const BROWSE_MODE_PATH = '/browse/mode';
export const BROWSE_MODE_PAGENAME = 'BrowsePageMode';
export const METADATA_MODULE_PATH = '/metadata';
export const METADATA_MODULE_PAGENAME = 'MetadataModule';
export const METADATADETAIL_PATH = '/metadata';
export const METADATADETAIL_PAGENAME = 'MetadataDetailPage';
export const METADATAREVIEW_PATH = '/review';
export const METADATAREVIEW_PAGENAME = 'MetadataReviewPage';
export const GCMD_PATH = '/gcmd';
export const GCMD_PAGENAME = 'GCMDPage';
export const ABOUT_PATH = '/about';
export const ABOUT_PAGENAME = 'AboutPage';
export const POLICIES_PATH = '/policies';
export const POLICIES_PAGENAME = 'PoliciesPage';
export const GUIDELINES_PATH = '/guidelines';
export const GUIDELINES_PAGENAME = 'GuidelinesPage';
export const DMP_PATH = '/dmp';
export const DMP_PAGENAME = 'DMPPage';
export const PROJECTS_PATH = '/projects';
export const PROJECTS_PAGENAME = 'ProjectsPage';
export const ORGANIZATIONS_PATH = '/organizations';
export const ORGANIZATIONS_PAGENAME = 'OrganizationsPage';
export const PROJECT_DETAIL_PATH = '/projects';
export const PROJECT_DETAIL_PAGENAME = 'ProjectDetailPage';
export const REPORT_PATH = '/report';
export const REPORT_PAGENAME = 'ReportPage';
export const PAGENOTFOUND_PAGENAME = 'PageNotFound';

export const METADATAEDIT_PATH = '/edit';
export const METADATAEDIT_PAGENAME = 'MetadataEditPage';

export const METADATA_CREATION_PATH = '/new';
export const METADATA_CREATION_PAGENAME = 'MetadataCreationPage';

export const USER_SIGNIN_PATH = '/signin';
export const USER_SIGNIN_PAGENAME = 'SigninPage';
export const USER_DASHBOARD_PATH = '/dashboard';
export const USER_DASHBOARD_PAGENAME = 'DashboardPage';
export const USER_SIGNOUT_PATH = '/signout';

export const BLOG_PATH = '/blog';
export const BLOG_PAGENAME = 'BlogPage';
export const INTEGRATION_PATH = '/integration';
export const INTEGRATION_PAGENAME = 'IntegrationPage';
export const SERVICE_PATH = '/services';
export const SERVICE_PAGENAME = 'ServicePage';

// route new workflow
export const WORKFLOW_PATH = '/workflow';
export const WORKFLOW_PAGENAME = 'WorkflowPage';
